import { Users, UserPlus, MailCheck, CalendarClock } from 'lucide-react';
import { UserStats } from './users-helpers';
import { StatCard } from '../../components/ui/StatCard';

interface UserStatsCardsProps {
  stats: UserStats;
}

export function UserStatsCards({ stats }: UserStatsCardsProps) {
  const marketingPct = stats.totalUsers > 0 ? Math.round((stats.marketingConsent / stats.totalUsers) * 100) : 0;
  const weeklyTipsPct = stats.totalUsers > 0 ? Math.round((stats.weeklyTips / stats.totalUsers) * 100) : 0;

  return (
    <div className="grid grid-cols-2 gap-3 sm:gap-4 lg:grid-cols-4">
      <StatCard icon={Users} label="Total Users" value={stats.totalUsers} hint="Registered users" />
      <StatCard icon={UserPlus} label="New Users (7 days)" value={stats.recentUsers} hint="Recent signups" trend="up" />
      <StatCard icon={MailCheck} label="Marketing Consent" value={stats.marketingConsent} hint={`${marketingPct}% of users`} />
      <StatCard icon={CalendarClock} label="Weekly Tips" value={stats.weeklyTips} hint={`${weeklyTipsPct}% of users`} />
    </div>
  );
}
